import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import { DASHBOARD_PATH } from 'config';

// project hooks
import useAuth from 'hooks/useAuth';
import { CircularProgress, Stack } from '@mui/material';
import { verifyToken } from 'contexts/auth/session';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */
const GuestGuard = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);

    const { isLoggedIn } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        let isMounted = true;

        (async () => {
            const resVerifyToken = await verifyToken(localStorage.getItem('serviceToken'));

            if (isMounted) {
                setIsLoading(true);

                if (isLoggedIn && resVerifyToken) {
                    navigate(DASHBOARD_PATH, { replace: true });
                }

                setIsLoading(false);
            }
        })();

        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    return isLoading ? (
        <Stack sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <CircularProgress />
        </Stack>
    ) : (
        children
    );
};

GuestGuard.propTypes = {
    children: PropTypes.node
};

export default GuestGuard;
